import { FileText } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup } from '../nav-node'

export function buildDocumentFilingGroup(ctx: StaffNavContext): StaffNavGroup | null {
  if (!ctx.showDocumentFilingSubmit) return null
  return group(
    'document_filing',
    'Documents',
    FileText,
    ['documents', 'filing', 'outstanding'],
    [
      leaf(
        'document_filing_outstanding',
        'Outstanding',
        AppPaths.documentFilingOutstanding,
        FileText,
        ['documents', 'outstanding', 'upload'],
        { activeWhenPrefix: true },
      ),
    ],
  )
}
